// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2VuFE","emails":"CreateEditClinics_emails__1zr8p","emailTagLabel":"CreateEditClinics_emailTagLabel__1WgpT"};